/*
 * SVG Editor
 * version: 1.0.1
 *
 */
/* eslint-disable */
import { useState, useEffect } from 'react';
import FabricCanvas from './components/FabricCanvas';
//import ChangeSport from './components/ChangeSport';
import __ from './utils/translation';
import saveInBrowser from './utils/saveInBrowser';
import { undo, redo } from './utils/undoRedo';
import { editorTips } from './utils/editorTips';
import { handleDrawingModes } from './utils/handleDrawingModes';
import { applyZoom, zoomWithKeys, zoomWithMouse } from './utils/zoom';
import './SimulatorIframe.scss';
import { IframeViewer } from "./js/iframe/iframe-viewer";
import Button from './components/Button';
import { Undo2Icon, Redo2Icon } from "lucide-react";
import Cloth from './components/Cloth';
import Light from './components/Light';

const SimulatorIframe = () => {

  window.canvasLoaded = false;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var is_iframe = urlParams.get('i');

  if (is_iframe) {
    import('./editorIframe.js')
      .then((module) => {
        if (window.name == "not-logged") {
          window.name = "logged";


          window["initSimulatorIframe"]();
          //initSimulatorIframe();
        }
      });
  }

  // states
  const [notification, setNotification] = useState({ message: null, type: null, seconds: null })
  const [downloadMenuVisible, setDownloadMenuVisible] = useState(false)
  const [activeTool, setActiveTool] = useState('select')
  const [canvas, setCanvas] = useState()
  const [loadSavedCanvas, setLoadSavedCanvas] = useState(true)
  const [activeSelection, setActiveSelection] = useState(null)
  const [history, setHistory] = useState({ index: null, states: [] })
  const [selectionInfo, setSelectionInfo] = useState(editorTips[Math.floor(Math.random() * editorTips.length)])
  const [zoom, setZoom] = useState(1)

  // on start: check if there is a saved canvas in this browser and ask if we should load it
  useEffect(() => {
    if (canvas && loadSavedCanvas) {
      const savedCanvas = saveInBrowser.load('canvasEditor');
      if (savedCanvas && window.confirm(__('We found a project saved in this browser! Do you want to load it?'))) {
        canvas.loadFromJSON(savedCanvas, canvas.renderAll.bind(canvas));
      }

      setLoadSavedCanvas(false);
    }
  }, [canvas, loadSavedCanvas])

  // on active selection update: change active tool to select
  useEffect(() => {
    if (!activeSelection) return

    //setActiveTool('select')

    // scroll to top in tool panel
    document.querySelector('.toolpanel .holder').scrollTop = 0
  }, [activeSelection])

  // on active tool change: deselect all object, handle drawing modes
  useEffect(() => {
    if (!canvas) return

    if (activeTool !== 'select') canvas.discardActiveObject().requestRenderAll()

    handleDrawingModes(canvas, activeTool, setSelectionInfo)
  }, [canvas, activeTool])

  // save history and unsaved work alert
  const maxHistory = 10
  useEffect(() => {
    if (!canvas) return

    const saveHistory = () => {
      let updatedHistory = [...history.states]

      // if any action happens after undo, clear all (redo) actions after current state
      if (history.index < history.states.length - 1) updatedHistory.splice(history.index + 1)

      // add current state to history
      updatedHistory.push(canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY',
        'hasControls', 'default', 'id', 'scaleX', 'scaleY']))
      if (updatedHistory.length > maxHistory) updatedHistory.shift()

      setHistory({ index: updatedHistory.length - 1, states: updatedHistory })
    }
    canvas.on('object:modified', saveHistory)
    canvas.on('path:created', saveHistory)

    const unsavedWorkAlert = (e) => {
      if (history.states.length > 1) e.returnValue = __(`Are you sure you want to leave?`)
    }
    window.addEventListener('beforeunload', unsavedWorkAlert)

    // cleanup
    return () => {
      canvas.off('object:modified', saveHistory)
      canvas.off('path:created', saveHistory)

      window.removeEventListener('beforeunload', unsavedWorkAlert)
    }
  }, [canvas, history])

  // keyboard & mouse shortcuts
  useEffect(() => {
    if (!canvas) return

    // select tool (v)
    const keyV = (e) => {
      const key = e.which || e.keyCode;
      if (key === 86 && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        //setActiveTool('select')
      }
    }
    document.addEventListener('keydown', keyV)

    // undo/redo (ctrl z/y)
    const ctrZY = (e) => {
      const key = e.which || e.keyCode;

      if (key === 90 && e.ctrlKey && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        undo(canvas, history, setHistory)
      }

      if (key === 89 && e.ctrlKey && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        redo(canvas, history, setHistory)
      }
    }
    document.addEventListener('keydown', ctrZY)

    // zoom out/in/reset (ctr + -/+/0)
    const keyZoom = (e) => zoomWithKeys(e, canvas, setZoom, applyZoom)
    document.addEventListener('keydown', keyZoom)

    // zoom out/in with mouse
    const mouseZoom = (e) => zoomWithMouse(e, canvas, setZoom, applyZoom)
    document.addEventListener('wheel', mouseZoom, { passive: false })

    // cleanup
    return () => {
      document.removeEventListener('keydown', keyV)
      document.removeEventListener('keydown', ctrZY)
      document.removeEventListener('keydown', keyZoom)
      document.removeEventListener('wheel', mouseZoom)
    }
  }, [canvas, history])

  // render layout
  return (
    <div id="app" className='iframe'>

      {/**<div className='toolpanel_panel' id="ChangeSport">
        <ChangeSport canvas={canvas} />
      </div> */}

      <div className='hidden' id="Light">
        <Light canvas={canvas} />
      </div>

      <div className='toolpanel_panel toolpanel_panel2 p-2' id="Cloth">
        <Cloth canvas={canvas} />
      </div>

      <IframeViewer />

      <Button id="undo-svg" className='svg !hidden' title={__('Undo')} handleClick={() => undo(canvas, history, setHistory)}
      ><Undo2Icon></Undo2Icon></Button>

      <Button id="redo-svg" className='svg !hidden' title={__('Redo')} handleClick={() => redo(canvas, history, setHistory)}
      ><Redo2Icon></Redo2Icon></Button>

      <div id='menu-anim-controls'>
        <div>
          <label>Estado</label>
          <i id='state-anim2' className="fas fa-play"></i>
        </div>
        <div>
          <label>Tempo</label>
          <input type="range" id="anim-time" name="animação tempo" min="0" max="1" defaultValue={0} step="0.01" />
        </div>
        <div>
          <label>Velocidade</label>
          <input type="range" id="anim-speed" name="animação velocidade" min="0" max="1" defaultValue={0} step="0.01" />
        </div>
      </div>

      <FabricCanvas canvas={canvas} setCanvas={setCanvas}
        selectionInfo={selectionInfo} setSelectionInfo={setSelectionInfo}
        setActiveSelection={setActiveSelection}
        setHistory={setHistory} />

      <div id="holding_img_iframe" className='btn-iframe'></div>
    </div>
  )
}

export default SimulatorIframe